export default "__VITE_ASSET__BWGiQluL__"